import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e83b1fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "idi" }
const _hoisted_2 = { class: "idi__elm" }
const _hoisted_3 = { class: "idi__elm-backward" }
const _hoisted_4 = { class: "idi__elm-backward-col" }
const _hoisted_5 = { class: "idi__elm-backward-col" }
const _hoisted_6 = { class: "idi__elm-info" }
const _hoisted_7 = {
  key: 0,
  class: "idi__elm-info-label"
}
const _hoisted_8 = {
  key: 1,
  class: "idi__elm-info-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Канал:", -1))
const _hoisted_10 = { class: "idi__elm-info-item-val" }
const _hoisted_11 = {
  key: 2,
  class: "idi__elm-info-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Канал активен до:", -1))
const _hoisted_13 = { class: "idi__elm-info-item-val" }
const _hoisted_14 = { class: "idi__elm-info-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "API URL:", -1))
const _hoisted_16 = { class: "idi__elm-info-item-val" }
const _hoisted_17 = { class: "idi__elm-info-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Id Instance:", -1))
const _hoisted_19 = { class: "idi__elm-info-item-val" }
const _hoisted_20 = { class: "idi__elm-info-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Api Token Instance:", -1))
const _hoisted_22 = { class: "idi__elm-info-item-val" }
const _hoisted_23 = { class: "idi__elm-info-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Статус:", -1))
const _hoisted_25 = { class: "idi__elm-info-item-val" }
const _hoisted_26 = {
  key: 3,
  class: "idi__elm-info-item"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Дата остановки:", -1))
const _hoisted_28 = { class: "idi__elm-info-item-val" }
const _hoisted_29 = {
  key: 4,
  class: "idi__elm-info-item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Канал удален:", -1))
const _hoisted_31 = { class: "idi__elm-info-item-val" }
const _hoisted_32 = {
  key: 5,
  class: "idi__elm-info-item"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Телефон:", -1))
const _hoisted_34 = { class: "idi__elm-info-item-val" }
const _hoisted_35 = {
  key: 6,
  class: "idi__elm-info-item"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, " Последний авторизованный телефон: ", -1))
const _hoisted_37 = { class: "idi__elm-info-item-val" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-item-key" }, "Опции:")
], -1))
const _hoisted_39 = { key: 7 }
const _hoisted_40 = { class: "idi__elm-info-option" }
const _hoisted_41 = { class: "idi__elm-info-option-val" }
const _hoisted_42 = { class: "idi__elm-info-option-val" }
const _hoisted_43 = { class: "idi__elm-info-option-checkbox" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-option-checkbox-title" }, " Автопродление ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "idi__elm-info-line" }, null, -1))
const _hoisted_46 = {
  key: 8,
  class: "idi__elm-info-footer"
}
const _hoisted_47 = { class: "idi__elm-info-footer-item" }
const _hoisted_48 = { class: "idi__elm-info-footer-item-icon" }
const _hoisted_49 = { class: "idi__elm-info-footer-item" }
const _hoisted_50 = { class: "idi__elm-info-footer-item-icon" }
const _hoisted_51 = {
  key: 0,
  class: "idi__elm-info-footer-item"
}
const _hoisted_52 = { class: "idi__elm-info-footer-item-icon" }
const _hoisted_53 = { class: "idi__elm-info-footer-item" }
const _hoisted_54 = {
  key: 9,
  class: "idi__elm-info-footer-m"
}
const _hoisted_55 = { class: "idi__elm-info-footer-m-btn" }
const _hoisted_56 = {
  key: 10,
  class: "idi__elm-info-footer-m-icons"
}
const _hoisted_57 = { class: "idi__elm-info-footer-m-icons-exit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiStatusIndicator = _resolveComponent("UiStatusIndicator")!
  const _component_UiSwitcher = _resolveComponent("UiSwitcher")!
  const _component_IconExit = _resolveComponent("IconExit")!
  const _component_IconRestart = _resolveComponent("IconRestart")!
  const _component_IconTrash = _resolveComponent("IconTrash")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.device.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "idi__elm-backward-col-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoBack && _ctx.onGoBack(...args)))
              }, [
                _createVNode(_component_IconArrowLeft, { color: "rgb(49, 49, 50)" })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "idi__elm-backward-col-label",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onGoBack && _ctx.onGoBack(...args)))
          }, _toDisplayString(_ctx.instance.instance), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiButton, {
            onClick: _ctx.onModalEventLog,
            label: "Последние действия",
            "border-color": "rgb(223, 230, 238)",
            "background-color": "rgb(223, 230, 238)"
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Информация "))
          : _createCommentVNode("", true),
        (_ctx.instanceChannelName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.instanceChannelName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.instanceExpired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.dataTimeFormat(_ctx.instanceExpired)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.instanceApiUrl), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.instance.instance), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.instance.token), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_UiStatusIndicator, {
              value: Number(_ctx.instance.status)
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.instancePauseStamp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.dataTimeFormat(_ctx.instancePauseStamp)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.instanceDeletedStamp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.dataTimeFormat(_ctx.instanceDeletedStamp)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.instance.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.formatPhoneNumber(_ctx.instance.phone)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.instance.last_auth_phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.formatPhoneNumber(_ctx.instance.last_auth_phone)), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_38,
        (_ctx.instance.status !== _ctx.STATUS.DELETE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidOptions, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.getOptionById(item.option_id).name), 1),
                    _createElementVNode("div", _hoisted_42, " до " + _toDisplayString(_ctx.dataTimeFormat(item.expire_stamp)), 1),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_UiSwitcher, {
                        "is-array-items": true,
                        "item-id": item.option_id,
                        name: `renewal_${item.option_id}`,
                        "is-checked": !!item.need_renew,
                        onCheckedItem: _ctx.onCheckboxAutoRenew
                      }, null, 8, ["item-id", "name", "is-checked", "onCheckedItem"])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _hoisted_45,
        (!_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_IconExit, {
                    color: 
									_ctx.instance.status === _ctx.STATUS.WAITING ||
									_ctx.instance.status === _ctx.STATUS.WAITING_5 ||
									_ctx.instance.status === _ctx.STATUS.DELETE ||
									_ctx.instance.status === _ctx.STATUS.PROCESS
										? 'rgb(234,234,234)'
										: 'rgb(119, 121, 124)'
								
                  }, null, 8, ["color"])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLogoutInstance && _ctx.onLogoutInstance(...args))),
                  class: _normalizeClass(
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5 ||
								_ctx.instance.status === _ctx.STATUS.DELETE ||
								_ctx.instance.status === _ctx.STATUS.PROCESS
									? 'idi__elm-info-footer-item-label_notactive'
									: 'idi__elm-info-footer-item-label'
							)
                }, " Выйти ", 2)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_IconRestart, {
                    color: 
									_ctx.instance.status === _ctx.STATUS.DELETE || _ctx.isClickRebootBtn
										? 'rgb(234,234,234)'
										: '#77797C'
								
                  }, null, 8, ["color"])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRebootInstance && _ctx.onRebootInstance(...args))),
                  class: _normalizeClass(
								_ctx.instance.status === _ctx.STATUS.DELETE || _ctx.isClickRebootBtn
									? 'idi__elm-info-footer-item-label_notactive'
									: 'idi__elm-info-footer-item-label'
							)
                }, " Перезапустить ", 2)
              ]),
              (_ctx.isShowDeleteAction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_IconTrash, {
                        color: 
									_ctx.instance.status !== _ctx.STATUS.DELETE
										? '#E83941'
										: 'rgb(234,234,234)'
								
                      }, null, 8, ["color"])
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDeleteInstance && _ctx.onDeleteInstance(...args))),
                      class: _normalizeClass(
								_ctx.instance.status !== _ctx.STATUS.DELETE
									? 'idi__elm-info-footer-item-label_red'
									: 'idi__elm-info-footer-item-label_grey'
							)
                    }, " Удалить ", 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_UiButton, {
                  onClick: _ctx.onGetQrCode,
                  label: "Получить QR-код",
                  "background-color": 
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							,
                  "border-color": 
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							,
                  color: "rgb(255, 255, 255)",
                  "font-weight": "600",
                  "font-size": "16px"
                }, null, 8, ["onClick", "background-color", "border-color"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_UiButton, {
                  onClick: _ctx.onGetQrCode,
                  label: "Получить QR-код",
                  "background-color": 
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							,
                  "border-color": 
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5
									? 'var(--theme-color)'
									: 'rgb(244, 246, 250)'
							,
                  color: "rgb(255, 255, 255)",
                  "font-weight": "600",
                  "font-size": "16px"
                }, null, 8, ["onClick", "background-color", "border-color"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_IconExit, {
                  color: 
								_ctx.instance.status === _ctx.STATUS.DELETE ||
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5 ||
								_ctx.instance.status === _ctx.STATUS.PROCESS
									? 'rgb(234,234,234)'
									: 'rgb(119, 121, 124)'
							
                }, null, 8, ["color"]),
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLogoutInstance && _ctx.onLogoutInstance(...args))),
                  class: _normalizeClass(
								_ctx.instance.status === _ctx.STATUS.DELETE ||
								_ctx.instance.status === _ctx.STATUS.WAITING ||
								_ctx.instance.status === _ctx.STATUS.WAITING_5 ||
								_ctx.instance.status === _ctx.STATUS.PROCESS
									? 'idi__elm-info-footer-m-icons-exit-label_notactive'
									: 'idi__elm-info-footer-m-icons-exit-label'
							)
                }, " Выйти ", 2)
              ]),
              _createVNode(_component_IconRestart, {
                onClick: _ctx.onRebootInstance,
                color: 
							_ctx.instance.status === _ctx.STATUS.DELETE || _ctx.isClickRebootBtn
								? 'rgb(234,234,234)'
								: '#77797C'
						
              }, null, 8, ["onClick", "color"]),
              (_ctx.isShowDeleteAction)
                ? (_openBlock(), _createBlock(_component_IconTrash, {
                    key: 0,
                    onClick: _ctx.onDeleteInstance,
                    color: 
							_ctx.instance.status !== _ctx.STATUS.DELETE
								? '#E83941'
								: 'rgb(244, 246, 250)'
						
                  }, null, 8, ["onClick", "color"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}